module.exports = __webpack_public_path__ + "static/media/consultation-img.47814435.png";